export class TableConfig {
    tableName: string;
    columns: ColumnConfig[] = []
}

export class ColumnConfig {
    name: string;
    visible: boolean;
    backgroundColor: string;
}